<template>
  <div class="page-content-container">
    <div class="search-container mb-12">
      <el-input
        class="w-120 mr-12"
        placeholder="昵称 / 姓名 "
        prefix-icon="el-icon-search"
        v-model.trim="searches"
        size="mini"
        clearable
        @keyup.enter.native="getdata"
      ></el-input>
      <el-input
        class="w-135 mr-12"
        placeholder="微信 unionid "
        prefix-icon="el-icon-search"
        v-model.trim="union_id"
        size="mini"
        clearable
        @keyup.enter.native="getdata"
      ></el-input>
      <el-input
        class="w-135 mr-12"
        placeholder="平台 id "
        prefix-icon="el-icon-search"
        v-model.trim="platform_id"
        size="mini"
        clearable
        @keyup.enter.native="getdata"
      ></el-input>
      <el-button type="primary" size="mini" plain @click="getdata"
        >查询</el-button
      >
      <el-button size="mini" @click="clearSearch">重置</el-button>
    </div>
    <el-table border :data="list" :stripe="true">
      <el-table-column label="编号" prop="index" width="100"></el-table-column>
      <el-table-column label="昵称 / 姓名" width="100">
        <template slot-scope="scope">
          <div>{{ scope.row.username || scope.row.wx_name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="行业" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.industry">
            {{ scope.row.industry }}
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="岗位" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.job">
            {{ scope.row.job }}
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
        width="90"
        label="已测技能点"
        prop="stack_count"
      ></el-table-column>
      <el-table-column
        width="80"
        label="总技能力"
        prop="stack_score"
      ></el-table-column>
      <el-table-column width="175" label="注册时间">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="微信 unionid"
        width="260"
        prop="wx_unionid"
      ></el-table-column>
      <el-table-column label="平台 id" prop="platform_id"></el-table-column>
      <el-table-column width="80" label="操作">
        <template slot-scope="scope">
          <el-link :underline="false" @click="goDetail(scope.row.no)"
            >查看报告</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      @change-size="changeSize"
      @change-page="changePage"
      :currentPage="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
    >
    </Pagination>
  </div>
</template>

<script>
import userService from "../global/service/user";
import Pagination from "../components/Pagination.vue";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      searches: "",
      union_id: "",
      platform_id: "",
      list: [],
      loading: true,
      pagination: {
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      const params = {
        union_id: this.union_id,
        search: this.searches,
        platform_id: this.platform_id,
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
      };
      this.loading = true;
      userService
        .getUserList(params)
        .then((res) => {
          this.list = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
          let num = this.pagination.total + 1;
          for (let index = 0; index < this.list.length; index++) {
            if (params.page == 1) {
              num = num - 1;
              this.list[index].index = num;
            } else {
              num = num - 1;
              this.list[index].index =
                num - params.page_size * (params.page - 1);
            }
          }
        })
        .finally(() => (this.loading = false));
    },
    clearSearch() {
      this.searches = "";
      this.union_id = "";
      this.platform_id = "";
      this.pagination.currentPage = 1;
      this.getdata();
    },
    goDetail(id) {
      const url = `https://www${process.env.VUE_APP_PRODEGREE_DOMAIN}/report/read/${id}`;
      window.open(url);
    },
    changeSize(e) {
      this.pagination.pageSize = e;
      this.getdata();
    },
    changePage(e) {
      this.pagination.currentPage = e;
      this.getdata();
    },
  },
};
</script>
<style lang="less" scoped></style>
